
const formatarDataISO = (date) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const dia = String(date.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
};

const formatarDataBR = (dataStr) => {
    try {
        if (!dataStr || typeof dataStr !== 'string') return new Date(0);

        const [d, t] = dataStr.split(" ");
        const [dia, mes, ano] = d.split("/").map(Number);
        const [h, m, s] = t.split(":").map(Number);

        if (!dia || !mes || !ano) return new Date(0);
        return new Date(ano, mes - 1, dia, h || 0, m || 0, s || 0);
    } catch (error) {
        return new Date(0);
    }
};

const tempoRelativoBR  = (dataStr) => {
    const data = formatarDataBR(dataStr);
    if (isNaN(data)) return "";

    const agora = new Date();
    const diffMs = agora - data;
    const diffMinutos = Math.floor(diffMs / (1000 * 60));
    const diffHoras = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    const horaFormatada = data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit"
    });

    if (diffMinutos < 1) return `Agora (${horaFormatada})`;
    if (diffMinutos < 60) return `${diffMinutos} min atrás (${horaFormatada}h)`;
    if (diffHoras < 24) return `${diffHoras} h atrás (${horaFormatada}h)`;
    if (diffDias === 1) return `Ontem (${horaFormatada})`;
    if (diffDias < 7) return `${diffDias} dias atrás (${horaFormatada})`;

    return `${data.toLocaleDateString("pt-BR")} ${horaFormatada}`;
};


export { formatarDataISO, formatarDataBR, tempoRelativoBR };